<template>
    <div>{{ desc }}</div>
</template>

<script>
export default {
    data: () => ({
    }),
    mounted() {
    },
    computed: {
        desc() {
            const desc = this.$root.$route.meta.title  || ''
            return (desc) ? this.$root.$t('home.home_cards.' + desc + '_about') : ''
        }
    }
}
</script>
